import { StyleSheet } from 'react-native'

export const useStyles = (theme, windowHeight) => StyleSheet.create({
  container: {
    paddingBottom: 20,
    height: windowHeight ? windowHeight * 0.9 : 'auto'
  },
  inputContainer: {
    height: 40,
    paddingLeft: 20,
    marginBottom: 20,
    borderWidth: 1,
    borderColor: theme.INPUT_COLOR,
    borderRadius: 3,
    flexDirection: 'row',
    alignItems: 'center'
  },
  inputScrollViewContainer: {
    flexDirection: 'row',
    overflow: 'scroll',
    alignItems: 'center',
    width: '100%'
  },
  inputIcon: {
    marginRight: 10
  },
  elementsInputContainer: {
    borderBottomWidth: 0
  },
  elementsInput: {
    minWidth: 100,
    color: theme.BUNKER
  },
  optionsContainer: {
    margin: 0,
    paddingHorizontal: 0,
    paddingVertical: 5,
    backgroundColor: theme.CARD_BACKGROUND,
    borderColor: theme.INPUT_COLOR,
    borderRadius: 5
  },
  option: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 10,
    paddingHorizontal: 20
  },
  checkbox: {
    alignSelf: 'center',
    width: 20,
    height: 20
  },
  multiselectedContainer: {
    flexDirection: 'row'
  },
  multiselectedBadget: {
    marginRight: 5,
    backgroundColor: theme.CATSKILL_WHITE
  },
  multiselectedOption: {
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 5

  },
  multiselectedText: {
    fontSize: 13
  },
  multiselectedIcon: {
    margin: 5
  },
  buttonContainer: {
    margin: 20,
    alignItems: 'flex-end'
  },
  notResultsMessage: {
    margin: 20
  }
})
